// src/index.tsx
import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { Provider } from "react-redux";
import { store } from "./app/store";

/**
 * Top-level mount: Provider is at index so App and pages can use store/hooks directly.
 *
 * NOTE: If your App() already wraps Provider(store) (from earlier snippets),
 * remove that Provider inside App to avoid double-provider problems.
 */

const container = document.getElementById("root");
if (!container) throw new Error("Root container missing in index.html");

const root = ReactDOM.createRoot(container);

root.render(
  <React.StrictMode>
    <Provider store={store}>
      <App />
    </Provider>
  </React.StrictMode>
);

// Log performance metrics (optional)
// pass console.log to see them in the browser console during development
reportWebVitals();
